import { z } from "zod";

import {
  createMutationRequestDefinition,
  createQueryRequestDefinition,
} from "~/lib/network/definitions/create";

import { loginCredentialsSchema } from "./credentials";

export const exchangeCodeForSessionMutation = createMutationRequestDefinition({
  host: "cap-srv",
  method: "GET",
  path: "/auth/workos/oasis-callback",
  paramsSchema: z.object({
    code: z.string(),
    state: z.string().optional(),
  }),
  responseSchema: loginCredentialsSchema,
  assumeUnAuthenticated: true,
});

export const getAuthRedirectUrlMutation = createMutationRequestDefinition({
  host: "cap-srv",
  method: "GET",
  path: "/auth/workos/authorize",
  paramsSchema: z.object({ callbackBaseUrl: z.string() }),
  responseSchema: z.object({
    url: z.string(),
  }),
  assumeUnAuthenticated: true,
});

export const logoutUserMutation = createMutationRequestDefinition({
  host: "cap-srv",
  method: "POST",
  path: "/auth/workos/logout",
  paramsSchema: z.object({}),
  responseSchema: z.object({}),
});

export const workosAuthenticationResponseSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),

  userId: z.string(),
});

export const refreshAccessTokenMutation = createMutationRequestDefinition({
  host: "cap-srv",
  method: "POST",
  path: "/auth/workos/refresh",
  // NOTE: requires refresh token in authorization header
  paramsSchema: z.object({
    oldAccessToken: z.string(),
  }),
  responseSchema: workosAuthenticationResponseSchema,
  assumeUnAuthenticated: true,
});

export const GetUserProfileRequestSchema = z.object({});

const userProfileSchema = z.object({
  userId: z.string(),
  name: z.string(),
  email: z.string(),
  permissions: z
    .array(z.string())
    .nullish()
    .transform((permissions) => permissions ?? []),
  metadata: z
    .record(z.string(), z.any())
    .nullish()
    .transform((metadata) => metadata ?? {}),
  isSegmentReviewAdmin: z.boolean().optional().default(false),
});
export type UserProfileType = z.infer<typeof userProfileSchema>;

export const getUserQuery = createQueryRequestDefinition({
  queryKey: ["user", "profile"],
  host: "cap-srv",
  method: "GET",
  path: "/oasis/user/profile",
  responseSchema: userProfileSchema,
});

export const createSessionMutation = createMutationRequestDefinition({
  host: "cap-srv",
  method: "POST",
  path: "/oasis/sessions/create",
  paramsSchema: z.object({
    justification: z.string(),
    durationMs: z.number(),
  }),
  responseSchema: z.object({
    sessionId: z.string(),
    expiresAt: z.number(),
  }),
});

export const changeUserRoleMutation = createMutationRequestDefinition({
  host: "cap-srv",
  method: "POST",
  path: "/oasis/user/change-role",
  paramsSchema: z.object({
    role: z.string(),
    refreshToken: z.string(),
  }),
  responseSchema: loginCredentialsSchema,
});

export const invalidateUserSessionsMutation = createMutationRequestDefinition({
  host: "cap-srv",
  method: "POST",
  path: "/auth/v2/invalidate-user-sessions",
  paramsSchema: z.object({
    userId: z.string(),
  }),
  responseSchema: z.object({}).passthrough(),
});
